<template>
  <b-modal
    id="modal-video-alert"
    :title="`${licensePlate} - ${language === 'en' ? descriptionEng : descriptionIdn}`"
    size="xl"
    centered
    :modal-class="`mc-modal-video mc-modal-video--liveview`"
    @show="onShowModal"
    @hidden="hideModalVideo"
  >
    <div class="mc-modal-video__Wrapper">
      <div class="mc-modal-video__top">
        <b-row>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.licensePlate') }}</span>
              <div>
                <strong>{{ licensePlate }}</strong>
              </div>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.fleetCategory') }}</span>
              <strong>{{ category ?? '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.driver') }}</span>
              <strong>{{ driver ?? '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.phoneNumber') }} GPS</span>
              <strong>{{ phoneNo ?? '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('liveView.infoWindow.imei') }}</span>
              <strong>{{ imei }}</strong>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mc-modal-video__content multi-evidence">
        <b-row>
          <b-col
            v-for="(ch, index) in listChannel"
            :key="index"
            md="6"
            sm="12"
            :md="listChannel.length % 2 === 1 && index === listChannel.length - 1 ? '12' : '6'"
            class="mb-4"
          >
            <h5 class="mc-notification-media__title">
              {{ $t('notification.text.videoCamera') }}
              {{ index + 1 }}
            </h5>
            <VideoAlert
              :channel="ch"
              :camera="index + 1"
              :checkIsDmsAdas="true"
              :vehicleIdCam="vehicleIdCam"
              :imeiCam="imeiCam"
              :videoUrl="dvhSelect(ch)?.url ?? ''"
              :mediaFilename="dvhSelect(ch)?.mediaFilename ?? ''"
              :statusDvh="dvhSelect(ch)?.status"
              :rawAlertCreatedOn="rawAlertCreatedOn"
              :deviceType="getDeviceType(deviceCode)"
              :alertCode="alertCode"
              :rawAlertId="rawAlertId"
            />
          </b-col>
        </b-row>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.close')"
          @click="cancel()"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import { Helper } from '@/mixin/helper'
import VideoPlayer from '@/components/Video/VideoPlayer.vue'
import VideoPlayerMux from '@/components/Video/VideoPlayerMux.vue'
import i18n from '../../../../../i18n'
import McButton from '@/components/McButton'
import VideoAlert from '@/components/VideoAlert/index.vue'

export default {
  components: {
    VideoPlayer,
    VideoPlayerMux,
    VideoAlert,
    McButton,
  },
  mixins: [Helper],
  props: {
    licensePlate: {
      type: String,
      required: false,
    },
    imei: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
    },
    driver: {
      type: String,
      required: false,
    },
    phoneNo: {
      type: String,
      required: false,
    },
    descriptionEng: {
      type: String,
      required: false,
    },
    descriptionIdn: {
      type: String,
      required: false,
    },
    statusText: {
      type: String,
      required: false,
    },
    dataDvh: {
      type: Array,
      required: false,
    },
    deviceCode: {
      type: Number,
      required: false,
    },
    vehicleIdCam: {
      type: Number,
      required: false,
    },
    imeiCam: {
      type: String,
      required: false,
    },
    rawAlertCreatedOn: {
      type: String,
      required: false,
    },
    alertCode: {
      type: Number,
      required: false,
    },
    rawAlertId: {
      type: Number,
      required: false,
    },
    createdOn: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      language: i18n.locale,
      wsMessageHandler: null,
    }
  },

  computed: {
    dataRequested() {
      return this.$store.state.notification.dataDvhRequested.filter(
        (d) => new Date(d.startTime).getTime() === new Date(this.createdOn).getTime()
      )
    },
    calculatedDataDvh() {
      return [...this.dataDvh, ...this.dataRequested]
    },
    listChannel() {
      const deviceType = this.getDeviceType(this.deviceCode)
      return this.statusText?.split(',').map((status) => {
        return deviceType === 'jc' ? parseInt(status) + 1 : parseInt(status)
      })
    },
    dataDvhChannel() {
      return (channel) => {
        return this.calculatedDataDvh.filter((video) => video.channel === channel)
      }
    },
    dvhSelect() {
      return (channel) => {
        const dataDvhChannel = this.dataDvhChannel(channel)
        const dvhF = dataDvhChannel.find((video) => video.status === 'F')
        const dvhI = dataDvhChannel.find((video) => video.status === 'I')
        const dvhS = dataDvhChannel.find((video) => video.status === 'S')
        if (dvhS) return dvhS
        else if (dvhI) return dvhI
        else if (dvhF) return dvhF
        return null
      }
    },
  },
  mounted() {
    this.addWsMessageHandler()
  },
  methods: {
    async addWsMessageHandler() {
      this.wsMessageHandler = this.handleWebSocketMessage.bind(this)
      await this.$store.dispatch('ws/registerMessageHandler', this.wsMessageHandler)
    },
    handleWebSocketMessage(message) {
      const signal = typeof message === 'string' ? JSON.parse(message) : message
      if (signal.type.startsWith('dvh-')) {
        const _dataDvh = signal.payload
        const dataDvhRequested = this.dataRequested
        const initInprogress = this.dataDvh.filter((d) => d.status === 'I')
        const isMatchRequest = [...dataDvhRequested, ...initInprogress].some(
          (d) => d.downloadId === _dataDvh.downloadId
        )
        if ((_dataDvh.status === 'S' || _dataDvh.status === 'F') && isMatchRequest) {
          if (dataDvhRequested.some((d) => d.downloadId === _dataDvh.downloadId)) {
            this.$store.commit('notification/updateDataDvhRequested', {
              downloadId: _dataDvh.downloadId,
              data: _dataDvh,
            })
          } else if (initInprogress.some((d) => d.downloadId === _dataDvh.downloadId)) {
            this.$emit('updateDataDvh', _dataDvh.downloadId, _dataDvh)
          }

          if (dataDvhRequested.status === 'S') {
            this.$mcToast.success(this.$t('notification.text.requestVideoSuccess'))
          } else if (dataDvhRequested.status === 'F') {
            this.$mcToast.error(this.$t('notification.text.requestVideoFailed'))
          }
        }
      }
    },
    hideModalVideo() {
      this.$bvModal.hide('modal-video-alert')
      this.$emit('close')
    },
    onShowModal() {},
  },
}
</script>
<style lang="scss">
div.mc-modal-video__content.multi-evidence {
  padding: 32px !important;
  max-height: 600px;
  overflow: scroll;
  .mc-video-alert__wrapper {
    height: 390px;
    position: relative;
    &:hover {
      .mc-notification-media__action {
        opacity: 1;
      }
    }
    .mc-notification-media__action {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      background-color: $teal;
      z-index: 2;
      color: $white;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      opacity: 0;
      transition: 0.3s;
      .mc-notification-media__loading-state {
        cursor: not-allowed;
        display: flex;
        align-items: center;
        column-gap: 4px;
        color: $teal-200;
      }
      span {
        cursor: pointer;
      }
      .mc-fa {
        &:before {
          color: $white;
        }

        &.icon-outline_download {
          margin-right: 5px;
        }
      }
    }
    .mc-notification-media__item--show {
      height: 100%;
    }
  }
  .mc-notification-media__item.mc-notification-media__item--show.mc-notification-media-video__fullscreen {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    .vjs-custom-skin,
    .video-js,
    video {
      height: 100% !important;
    }
  }
  .video-js {
    height: 390px !important;
    width: 100%;
    border-radius: 10px;
    video {
      border-radius: 10px;
    }
  }
}
</style>
